import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { SelectItem } from "primeng/api";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { BASE_API_URL } from "../../../../../core/environment.tokens";
import { CreatePendService } from "../../../../../shared/pend/create-pend.service";
import { RequestStatusChange } from "./request-status-change.model";

@Injectable()
export class InternalPendsRequestStatusChangeService {

  constructor(
    @Inject(BASE_API_URL) private readonly baseApiUrl: string,
    private readonly http: HttpClient,
    private route: ActivatedRoute,
    private readonly createPendService: CreatePendService
  ) { }

  getPendDropdown(isClinical: boolean, organizationId: number, isClientOnly: boolean, isReturnAllPendStatus: boolean): Observable<any> {
    return this.createPendService.getPendStatusDropdown(isClinical, organizationId, isClientOnly, isReturnAllPendStatus);
  }

  updateStatusChange(requestStatusChange: RequestStatusChange): Observable<any> {
    const url = `${this.baseApiUrl}Pend/UpdatePendStatus`;
    const headers = new HttpHeaders().set("content-type", "application/json");

    return this.http.post(url, requestStatusChange, { observe: "response" })
      .pipe(
        map((response: HttpResponse<any>): any => {
          if (response.ok) {

            return 1;
          } else {

            return 0;
          }
        })
      );
  }
}
